import React from 'react';

import { Layout, Text } from 'ds';
import { formatUsd } from 'helpers';
import { selectCleaningServicePricing } from 'store/CleaningService/selectors';
import { useAppSelector } from 'store/hooks';

import { threeMonthCleaningSchedule } from './utils';

interface CleaningServiceMonthBreakdownEstimateProps {
  monthSchedule: threeMonthCleaningSchedule;
}

const CleaningServiceMonthBreakdownEstimate: React.FC<CleaningServiceMonthBreakdownEstimateProps> = ({
  monthSchedule
}) => {
  const pricing = useAppSelector(selectCleaningServicePricing);

  if (!pricing) {
    return null;
  }

  const price =
    pricing.cleaning_price * monthSchedule.numStandardCleanings +
    pricing.touch_up_price * monthSchedule.numTouchUpCleanings;
  return (
    <Layout direction="column" gap={4}>
      <Layout direction="row" justify="space-between">
        <Text size="body-sm" semibold>
          {monthSchedule.month}
        </Text>
        <Text size="body-sm" semibold>
          {formatUsd(price)}
        </Text>
      </Layout>
      <Text size="body-xs" color="gray-400">
        Standard • Qty: {monthSchedule.numStandardCleanings} • {formatUsd(pricing.cleaning_price)} ea.
      </Text>
      {monthSchedule.numTouchUpCleanings > 0 && (
        <Text size="body-xs" color="gray-400">
          Touch Up • Qty: {monthSchedule.numTouchUpCleanings} • {formatUsd(pricing.touch_up_price)} ea.
        </Text>
      )}
    </Layout>
  );
};

export default CleaningServiceMonthBreakdownEstimate;
